import { getProfilPendampingSaya } from "../services/api";
import { getStoredUser, setStoredUser } from "./authStorage";

/**
 * Resolve id_pendamping untuk user R.45/R.47.
 * unik_id di localStorage bisa masih id PTSP (salah) — selalu validasi via profil-saya.
 */
export const resolvePendampingId = async () => {
  const user = getStoredUser();
  if (!user) return null;

  const role = (user.role || "").trim();
  if (user.userid && (role === "R.45" || role === "R.47")) {
    try {
      const { data } = await getProfilPendampingSaya(user.userid);
      if (data?.success && data.id_pendamping) {
        const updated = {
          ...user,
          unik_id: data.id_pendamping,
          id_pendamping: data.id_pendamping,
        };
        setStoredUser(updated);
        return data.id_pendamping;
      }
    } catch (_) {
      // fallback ke id lokal jika API gagal
    }
  }

  return user.id_pendamping || user.unik_id || null;
};
